import React from 'react'
import { useCookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'

import BoxContainer from '@components/box-container/BoxContainer'
import Avatar from '@components/avatar/Avatar'
import VertivalMenuItem from './VerticalMenuItem'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { faChartPie } from '@fortawesome/free-solid-svg-icons'
import { faPeopleGroup } from '@fortawesome/free-solid-svg-icons'
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons'

import './VerticalMenu.css'

function VerticalMenu() {
	const [, , removeCookie] = useCookies(['session_token'])
	const navigate = useNavigate()

	const handleDisconnect = () => {
		// Clear session token cookie
		removeCookie('session_token', { path: '/' })
	}

	return (
		<div id='verticalMenu'>
			<BoxContainer>
				<Avatar />
				<div id='itemsGroup'>
					<VertivalMenuItem
						icon={faBook}
						label='Formulaires'
						onClick={() => navigate('/form-admin')}
					/>
					<VertivalMenuItem icon={faChartPie} label='Dashboard' />
					<VertivalMenuItem icon={faPeopleGroup} label='Équipe' />
					<VertivalMenuItem
						icon={faArrowRightFromBracket}
						label='Déconnection'
						onClick={handleDisconnect}
					/>
				</div>
			</BoxContainer>
		</div>
	)
}

export default VerticalMenu
